// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__2UUp3","logo":"Footer_logo__-lowc","text":"Footer_text__0PPQT"};